<template>
    <multiselect :value="valueAsObject"
                 @input="inputValue($event)"
                 :options="optionsAsArray"
                 label="label"
                 track-by="id"
                 :multiple="multiple"
                 :searchable="searchable"
                 :show-labels="false"
                 :allow-empty="false"
                 :placeholder="placeholder" :disabled="disabled">
    </multiselect>
</template>

<script type="text/babel">
    import Multiselect from 'vue-multiselect';

    export default {
        props: {
            value: {
                default: 'value'
            },
            options: {
                type: [Array, Object],
                default: {}
            },
            multiple: {
                type: Boolean,
                default: false
            },
            searchable: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: 'Select'
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            optionsAsArray() {
                let vm = this,
                    options = [];

                Object.keys(this.options).forEach(function(key) {
                    options.push({
                        'id': String(key),
                        'label': vm.options[key]
                    });
                });

                return options;
            },

            valueAsObject() {
                let value = _.find(this.optionsAsArray, {id: String(this.value)});

                return typeof value !== 'undefined' ? value : {};
            }
        },

        methods: {
            inputValue(value) {
                if (value !== null) {
                    this.$emit('input', value.id);
                }
            }
        },

        components: {
            Multiselect
        }
    }
</script>
